<template>
  <div class="table-search">
    <div class="table-search-label">SEARCH</div>
    <div class="input-group">
      <input v-model="value" type="text" ref="search" class="form-control table-search-input" placeholder="Enter text to search">
      <span @click.prevent="reset()" :class="{ 'input-group-addon': true, 'primary': value.length > 0 }"><i class="pg-close_line"></i></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TableSearch',
    props: {
      search: {
        type: Function,
        default: (query) => {}
      }
    },
    data: () => ({
      value: ''
    }),
    methods: {
      reset() {
        this.value = '';
        this.search(this.value);
      }
    },
    created() {
      this.$watch('value', (value) => {
        this.search(value);
      });
    }
  }
</script>

<style>
  .table-search {
    margin: 30px 0;
  }
  .table-search-label {
    font-family: 'Montserrat';
    text-transform: uppercase;
    letter-spacing: 0.02em;
    font-size: 12px;
    font-weight: 600;
  }

  .table-search-input {    
    background: white;
    border: none;
    border-bottom: 1px solid #e8e8e8;
    text-align: left;
    text-transform: lowercase;
    letter-spacing: 0.02em;
    font-size: 12px;
    font-weight: 400;
  }

  .table-search .input-group {
    margin-top: 8px;
  }

  .table-search .input-group-addon {
    cursor: pointer;
  }
  .no-padding {
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// table_search.vue?46fd0e8c